import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { buildStyles } from "react-circular-progressbar";

function InsideStoryArea() {
  const aiPercentage = 88;
  const designPercentage = 92;
  const devPercentage = 90;

  return (
    <>
      <section className="about-area sec-mar">
        <div className="container">
          <div className="out-story">
            <div className="row">

              {/* LEFT IMAGE SECTION */}
              <div className="col-lg-6 col-xl-6">
                <div className="story-left">
                  <div className="office-group-img">
                    <img
                      src={process.env.PUBLIC_URL + "/images/story.png"}
                      alt="Gybits Team"
                    />

                    {/* Replaced fake CTO content */}
                    <div className="cto-message-wrapper">
                      <div className="cto-message">
                        <p>
                          Delivering smart, scalable, and future-ready digital solutions.
                        </p>
                        {/* <h4>
                          Gybits Team <span>AI & Software Experts</span>
                        </h4> */}
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-6 col-xl-6">
                <div className="story-right">

                  <div className="title black">
                    <span>About Gybits</span>
                    <h2 className="mb-15">
                      Building Intelligent Solutions for Modern Businesses
                    </h2>
                  </div>

                  <p>
                    At Gybits, we specialize in building intelligent, scalable, and 
                    high-performance digital solutions. From AI-powered automation 
                    to custom software and interactive game development, we help 
                    businesses transform ideas into impactful products. Our focus 
                    is on delivering real results through innovation, performance, 
                    and user-centric design.
                  </p>

                  {/* SKILLS SECTION */}
                  <div className="story-skills">

                    <div className="story-skill">
                      <CircularProgressbar
                        value={aiPercentage}
                        text={`${aiPercentage}%`}
                        strokeWidth={1}
                        styles={buildStyles({
                          pathColor: "#ff003c",
                          textColor: "#111",
                          trailColor: "#eee",
                        })}
                        className="progress-bar-circle"
                      />
                      <span>AI & Automation</span>
                    </div>

                    <div className="story-skill">
                      <CircularProgressbar
                        value={designPercentage}
                        text={`${designPercentage}%`}
                        strokeWidth={1}
                        styles={buildStyles({
                          pathColor: "#ff003c",
                          textColor: "#111",
                          trailColor: "#eee",
                        })}
                        className="progress-bar-circle"
                      />
                      <span>Web & App Design</span>
                    </div>

                    <div className="story-skill">
                      <CircularProgressbar
                        value={devPercentage}
                        text={`${devPercentage}%`}
                        strokeWidth={1}
                        styles={buildStyles({
                          pathColor: "#ff003c",
                          textColor: "#111",
                          trailColor: "#eee",
                        })}
                        className="progress-bar-circle"
                      />
                      <span>Development & Deployment</span>
                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default InsideStoryArea;